import { Typography } from '@speeki/global-ui-components';
import { IconManager, IconManagerProps } from '@speeki/icons';

import {
    MobileModal,
    MobileModalProps,
} from '@components/organisms/MobileModal/MobileModal';

import {
    RedirectModalButtons,
    RedirectModalContainer,
    RedirectModalInner,
} from './MobileRedirectModal.styled';

export interface MobileRedirectModal
    extends Pick<MobileModalProps, 'onClose' | 'open'> {
    buttons: React.ReactElement[];
    icon: IconManagerProps['icon'];
    text: string;
}

export const MobileRedirectModal = ({
    buttons,
    icon,
    onClose,
    open,
    text,
}: MobileRedirectModal) => {
    return (
        <MobileModal onClose={onClose} open={open} topPadding={80}>
            <RedirectModalContainer>
                <RedirectModalInner>
                    <IconManager icon={icon} size={65} />
                    {/* TODO: add font weight 500 after package release */}
                    <Typography.TextBody_16_24>
                        {text}
                    </Typography.TextBody_16_24>
                </RedirectModalInner>
                <RedirectModalButtons>{buttons}</RedirectModalButtons>
            </RedirectModalContainer>
        </MobileModal>
    );
};
